import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Button } from '@sumologic/yama-ds-components';

import Translate from '~/components/Translate/Translate';
import HeaderModal from '~/components/HeaderModal/HeaderModal';

const Confirm = props => {
    const {
        id,
        show,
        setShow,
        title,
        subtitle,
        description,
        descriptionInlineStyle,
        confirmLabel,
        onConfirm,
        onCancel,
        showCancelButton,
        className,
        isUndoPossible
    } = props;
    const modalClassname = ['confirm-dialog']
        .concat(className || 'default')
        .join('\u0020');
    const onCancelAction = () => {
        setShow(false);
        onCancel();
    };
    return (
        <Modal
            id={id}
            size="md"
            centered
            show={show}
            onHide={onCancelAction}
            className={modalClassname}
        >
            <HeaderModal
                title={title}
                description={subtitle || null}
                onHide={onCancelAction}
            />
            <Modal.Body>
                <div
                    className="mw-100 text-truncate"
                    style={descriptionInlineStyle}
                >
                    {description}
                </div>
            </Modal.Body>
            <Modal.Footer>
                {showCancelButton && (
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onCancelAction}
                    >
                        <Translate message="Cancel" />
                    </Button>
                )}
                <Button
                    variant="contained"
                    color={!isUndoPossible ? 'error' : 'primary'}
                    onClick={() => {
                        setShow(false);
                        onConfirm();
                    }}
                >
                    <Translate message={confirmLabel} />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

Confirm.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    className: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    descriptionInlineStyle: PropTypes.object,
    onCancel: PropTypes.func,
    confirmLabel: PropTypes.string,
    showCancelButton: PropTypes.bool,
    isUndoPossible: PropTypes.bool
};

Confirm.defaultProps = {
    title: 'Confirm',
    confirmLabel: 'Confirm',
    descriptionInlineStyle: null,
    showCancelButton: true,
    onCancel: () => {},
    isUndoPossible: true
};

export default Confirm;
